import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ComponentsModule } from '@tgx/shared/ui/components';
import { SharedModule } from '@openng/optimus-ui/api';
import { SharedUiStorybookModule } from '@tgx/shared/ui/storybook';
import { SkeletonModule } from '@openng/optimus-ui/skeleton';
import { UserPermissionsComponent } from './components/user-permissions/user-permissions.component';
import { UserInviteModalComponent } from './components/user-modal/user-invite-modal.component';

@NgModule({
  declarations: [UserPermissionsComponent, UserInviteModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    ComponentsModule,
    SharedModule,
    SharedUiStorybookModule,
    SkeletonModule,
  ],
  exports: [UserPermissionsComponent, UserInviteModalComponent],
})
export class UserManagementModule {}
